import { api } from "../index";
import { ExchangeRate, InvitationPaymentStatus, PaymentIntent } from "./dto/payment.dto";

const Payment_ENDPOINT = "/payment";

export const PaymentAPI = api.injectEndpoints({
	endpoints: build => ({
		postCreateIntent: build.mutation<{ clientSecret: string }, PaymentIntent>({
			query: body => ({
				url: `${Payment_ENDPOINT}/createPaymentIntent`,
				method: "POST",
				body: body
			})
		}),
		getInvitationPaymentStatus: build.query<InvitationPaymentStatus, { id: string }>({
			query: ({ id }) => ({
				url: `${Payment_ENDPOINT}/${id}/payment-status`,
				method: "GET"
			})
		}),
		getExchangeRateToday: build.query<{ exchangeRate: ExchangeRate }, void>({
			query: () => ({
				url: `/exchange-rate/today`,
				method: "GET"
			})
		}),
		getInvitationPlanPriceId: build.query<{ priceId: string }, { invitationId: string; targetPlan: number }>({
			query: ({ invitationId, targetPlan }) => ({
				url: `${Payment_ENDPOINT}/invitation/${invitationId}/${targetPlan}/price`,
				method: "GET"
			})
		})
	})
});

export const {
	usePostCreateIntentMutation,
	useGetExchangeRateTodayQuery,
	useLazyGetInvitationPlanPriceIdQuery,
	useLazyGetInvitationPaymentStatusQuery
} = PaymentAPI;
